export default __webpack_public_path__ + "static/media/onekeyWalletIcon.51e954b6.svg";